import { render } from "./ExpertStatisticsCallerNumbersReport.vue?vue&type=template&id=92fd255a&scoped=true"
import script from "./ExpertStatisticsCallerNumbersReport.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsCallerNumbersReport.vue?vue&type=script&lang=js"

import "./ExpertStatisticsCallerNumbersReport.vue?vue&type=style&index=0&id=92fd255a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92fd255a"]])

export default __exports__